import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getReportAccountPlatform = async (queries) => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/reporting/account-platform?${queries}` });

  return data?.data;
};

export default getReportAccountPlatform;
